const linkShopeeAffGenerator = (link, affIdList) => {
    const randomIndex = Math.floor(Math.random() * affIdList.length);
    const { aff_id, sub_id } = affIdList[randomIndex];
    const newAffLink = `https://shope.ee/an_redir?origin_link=${link}&affiliate_id=${aff_id}&sub_id=${sub_id}----`;
    return newAffLink;
};

export default linkShopeeAffGenerator;
